import { Button } from "@/components/ui/button";
import useSurvey from "@/containers/survey/hooks/useSurvey";
import { ArrowUp } from "lucide-react";
import { useFormState } from "react-hook-form";

interface MoveUpButtonProps {
  index: number;
  isFirst: boolean;
}

export default function MoveUpButton({ index, isFirst }: MoveUpButtonProps) {
  const survey = useSurvey();
  const { isSubmitting, disabled } = useFormState();
  return (
    <Button
      type="button"
      onClick={() => survey.moveQuestion(index, index - 1)}
      disabled={disabled || isFirst || isSubmitting}
      variant="ghost"
      size="icon"
      className="hover:bg-slate-200"
      data-testid="move-up"
    >
      <ArrowUp className="w-5 h-5" />
    </Button>
  );
}
